import { FilterGroup } from '../models';

/**
 * Filter groups configuration for the browse index sidebar.
 * Defines which filter panels appear, their Koha API field mapping,
 * and display behavior. Options are populated at runtime from the API.
 */
export const FILTER_GROUPS_CONFIG: Omit<FilterGroup, 'options' | 'selectedValues' | 'page' | 'hasMore' | 'loading' | 'totalCount' | 'searchTerm'>[] = [
  {
    key: 'library',
    label: 'FILTERS.INSTITUTION',           // المؤسسة
    field: 'items.homebranch',
    searchable: true,
    expanded: true,
    pageSize: 5,
  },
  // {
  //   key: 'itemtype',
  //   label: 'FILTERS.FORMAT',                // التنسيق
  //   field: 'item_type',
  //   searchable: true,
  //   expanded: true,
  //   pageSize: 5,
  // },
  {
    key: 'author',
    label: 'FILTERS.AUTHOR',
    field: 'author',
    searchable: true,
    expanded: true,
    pageSize: 5,
  },
  {
    key: 'publisher',
    label: 'FILTERS.PUBLISHER',
    field: 'publisher',
    searchable: true,
    expanded: true,
    pageSize: 5,
  },
  {
    key: 'publication_place',
    label: 'FILTERS.PUBLICATION_PLACE',
    field: 'publication_place',
    searchable: true,
    expanded: true,
    pageSize: 5,
  },
  // {
  //   key: 'publication_year',
  //   label: 'FILTERS.PUBLICATION_YEAR',
  //   field: 'publication_year',
  //   searchable: true,
  //   expanded: true,
  //   pageSize: 5,
  // }
];

/** Default number of items per page (3×3 grid) */
export const DEFAULT_PAGE_SIZE = 9;

/** Debounce time in milliseconds for search input */
export const SEARCH_DEBOUNCE_MS = 300;

/** API base path for Koha biblio endpoints */
export const KOHA_BIBLIOS_PATH = '/biblios';

/** API base path for Koha libraries endpoint */
export const KOHA_LIBRARIES_PATH = '/libraries';
